import React from 'react';
import ColorSelectItem from './ColorSelectItem.js';


class DesignerColorSelect extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(color) {
        this.props.onColorSelect(color);
    }

    render() {


        const colorSelectsDefault = this.props.colors.filter((color) => {return !color.special}).map((color) =>
            <ColorSelectItem
                key={color.id} 
                color={color} 
                active={color == this.props.activeColor} 
                onColorSelect={this.handleSelect}
            />
        );

        const colorSelectsSpecial = this.props.colors.filter((color) => {return color.special}).map((color) =>
            <ColorSelectItem
                key={color.id} 
                color={color} 
                active={color == this.props.activeColor} 
                onColorSelect={this.handleSelect}
            />
        );

        if (this.props.position == 'basket')
        {
            return (
                <div className="designer_color_select designer_controll">
                    <div className="designer_controll_title">
                        Druckfarbe:
                    </div>
                    <div className="designer_controll_actions">
                        {
                            colorSelectsSpecial.length > 0 ?
                            <div>
                                <div>
                                    Spezial Farben
                                </div>
                                {colorSelectsSpecial}
                                <div style={{ clear: 'left' }} />
                            </div>
                            : null
                        }
                        
                        <div>
                            <div>
                                Normale Farben
                            </div>
                            {colorSelectsDefault}
                            <div style={{ clear: 'left' }} />
                        </div>
                    </div>
                </div>
            );
        }
        else
        {
            return (
                <div className="designer_color_select designer_controll row hidden-sm">
                    <div className="designer_controll_title col-sm-2 col-md-1">
                        Druckfarbe:
                    </div>
                    <div className="designer_controll_actions col-sm-10 col-md-11">
                        {
                            colorSelectsSpecial.length > 0 ?
                            <div className="col-xs-12 nopadding-mobile">
                                <div>
                                    Spezial Farben
                                </div>
                                {colorSelectsSpecial}
                                <div style={{ clear: 'left' }} />
                            </div>
                            : null
                        }

                        <div className="col-xs-12 nopadding-mobile">
                            <div>
                                Normale Farben
                            </div>
                            {colorSelectsDefault}
                            <div style={{ clear: 'left' }} />
                        </div>
                        
                    </div>
                </div>
            );
        }
    }
  }
export default DesignerColorSelect;



// WEBPACK FOOTER //
// ./src/DesignerColorSelect.js